import ajaxFor from '@/utils/ajaxSet';

export function seek(params){

     return ajaxFor({
          url:'/Material/Material/searchMaterial',
          method:"post",
          data:params
     })

}
